import { component } from "picoapp";
import "slick-carousel";
import $ from "jquery";
/* eslint-disable func-style */
export const billboardSlider = component((node) => {
  const $slider = $(node)
    .not(".slick-initialized")
    .slick({
      slidesToScroll: 1,
      slidesToShow: 1,
      centerMode: true,
      arrows: true,
      prevArrow: $(".vote-billboard").find(".vote-billboard-arrow.left"),
      nextArrow: $(".vote-billboard").find(".vote-billboard-arrow.right"),
      rows: 0,
      dots: true,
      infinite: true,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 749,
          settings: {
            centerMode: false,
            arrows: false,
          },
        },
      ],
    });

  const setSliderDotsWidth = () => {
    const imageWidth = $(node).find("img").width();
    $(node)
      .find(".slick-dots")
      .css({ width: `${imageWidth}px` });
  };

  const resize = () => {
    if ($slider) {
      $slider.slick("setPosition");
    }
  };

  setSliderDotsWidth();

  $slider.on("setPosition", () => {
    setSliderDotsWidth();
  });

  window.addEventListener("resize", resize);

  return () => {
    window.removeEventListener("resize", resize);
  };
});

export const biosSlider = component((node) => {
  const $slider = $(node)
    .not(".slick-initialized")
    .slick({
      slidesToShow: 2,
      slidesToScroll: 2,
      arrows: true,
      prevArrow: $(".vote-bios").find(".vote-bios-arrow.left"),
      nextArrow: $(".vote-bios").find(".vote-bios-arrow.right"),
      dots: true,
      rows: 0,
      infinite: true,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 959,
          settings: {
            variableWidth: true,
            prevArrow: null,
            nextArrow: null,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

  const resize = () => {
    if ($slider) {
      $slider.slick("setPosition");
    }
  };

  window.addEventListener("resize", resize);

  return () => {
    window.removeEventListener("resize", resize);
  };
});
